import { Button } from "../../components/Button";
import { Card } from "../../components/Card";

export function PromotionsReviewPromoCard({
  title,
  subtitle,
  err,
  ok,
  submitting,
  onClick,
}) {
  return (
    <Card variant="light" className="promotionsPromoCard" title={title} subtitle={subtitle}>
      <div className="promotionsPromoCard__form">
        {err ? <p className="errorMessage">{err}</p> : null}
        {ok ? <p className="successMessage">{ok}</p> : null}
        <Button type="button" variant="accent" disabled={submitting} onClick={onClick}>
          {submitting ? "Обработка…" : "Перейти к отзывам и получить бонусы"}
        </Button>
      </div>
    </Card>
  );
}
